<template>
	<c-dialog ref="dialog" width="500" @resolve="submitHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="竞价堂账号" required>
				<c-input name="bidding_hall_username" placeholder="请输入您的竞价堂账号"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		name: 'sysuserBiddingHallBind',
		methods: {
			/*********打开绑定弹窗，初始化**********/
			open(data) {
				this.$refs.form.clear();
				this.$refs.form.set({
					id: data.id,
					//回填当前已绑定账号（若有），便于修改语义下再次确认
					bidding_hall_username: data.bidding_hall_username || ''
				});
				this.$refs.dialog.open({
					title: '绑定竞价堂'
				});
			},

			/*******提交绑定********/
			submitHandle(stop, next) {
				stop();
				this.$refs.form.submit({
					url: '/sys_user/bind_bidding_hall',
					rule: {
						bidding_hall_username: '请输入竞价堂账号'
					},
					success: (data, res) => {
						next();
						this.$message({
							message: '竞价堂绑定成功',
							type: 'success'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
